;(function () {
	const instances = new Map()

	const restartBulletAnimation = (section) => {
		section
			.querySelectorAll('.home-feature-slider__bullet-fill')
			.forEach((fill) => {
				fill.style.animation = 'none'
				fill.style.width = '0'
			})

		const activeFill = section.querySelector(
			'.home-feature-slider__pagination .swiper-pagination-bullet-active .home-feature-slider__bullet-fill'
		)
		if (!activeFill) return

		void activeFill.offsetWidth
		activeFill.style.width = ''
		activeFill.style.animation = `homeFeatureSliderFill ${section.style.getPropertyValue('--feature-slider-duration').trim()} linear forwards`
	}

	const updateDesktopOffsetAfter = (swiper) => {
		if (!swiper || window.innerWidth < 768) return

		const firstSlide = swiper.slides && swiper.slides[0]
		if (!firstSlide) return

		const slideWidth = firstSlide.offsetWidth
		const wrapperWidth = swiper.el.offsetWidth
		const gap = swiper.params.spaceBetween || 0
		const offsetAfter = Math.max(0, wrapperWidth - slideWidth - gap)

		if (swiper.params.slidesOffsetAfter !== offsetAfter) {
			swiper.params.slidesOffsetAfter = offsetAfter
			swiper.update()
		}
	}

	const initFeatureSlider = (section) => {
		if (!section) return

		const sectionId = section.dataset.sectionId
		if (instances.has(sectionId)) {
			instances.get(sectionId).destroy(true, true)
			instances.delete(sectionId)
		}

		const sliderElement = section.querySelector('.home-feature-slider__swiper')
		const paginationElement = section.querySelector('.home-feature-slider__pagination')
		const autoplayDelay = Number(section.dataset.autoplayDelay || 4000)

		section.style.setProperty('--feature-slider-duration', `${autoplayDelay}ms`)

		const swiper = new Swiper(sliderElement, {
			slidesPerView: 'auto',
			spaceBetween: 12,
			speed: 700,
			loop: false,
			rewind: true,
			initialSlide: 0,
			centeredSlides: false,
			watchSlidesProgress: false,
			autoplay: {
				delay: autoplayDelay,
				disableOnInteraction: false,
				pauseOnMouseEnter: false
			},
			pagination: {
				el: paginationElement,
				clickable: true,
				renderBullet: function (index, className) {
					return `<button class="${className}" type="button" aria-label="Go to slide ${index + 1}"><span class="home-feature-slider__bullet-fill"></span></button>`
				}
			},
			breakpoints: {
				768: {
					spaceBetween: 5 * 10,
					slidesOffsetAfter: 0
				}
			},
			on: {
				init() {
					updateDesktopOffsetAfter(this)
					restartBulletAnimation(section)
				},
				slideChange() {
					restartBulletAnimation(section)
				},
				resize() {
					updateDesktopOffsetAfter(this)
				},
				paginationUpdate() {
					restartBulletAnimation(section)
				}
			}
		})

		instances.set(sectionId, swiper)
	}

	const initAllFeatureSliders = () => {
		document.querySelectorAll('.home-feature-slider').forEach(initFeatureSlider)
	}

	document.addEventListener('DOMContentLoaded', function () {
		initAllFeatureSliders()
		document.addEventListener('shopify:section:load', function (event) {
			const slider = event.target.querySelector('.home-feature-slider')
			if (slider) {
				initFeatureSlider(slider)
			}
		})
	})
})()
